import OfficeResource from '@/common/resources/Office'

export const actions = {
	createOffice ({ commit }, data) {
		return new Promise((resolve, reject) => {
			console.log('===========DATA=============')
			console.log(data)
			console.log('========================')
			OfficeResource.createOffice(data).then((response) => {
				if (response.status === 200) {
					resolve(response.data)
				} else {
					reject(new Error('Une erreur est survenue'))
				}
			}).catch((error) => {
				reject(error)
			})
		})
	},
	updateOffice ({ commit }, data) {
		return new Promise((resolve, reject) => {
			OfficeResource.updateOffice(data.id, data.payload).then((response) => {
				if (response.status === 200) {
					resolve(response.data)
				} else {
					reject(new Error('Une erreur est survenue'))
				}
			}).catch((error) => {
				reject(error)
			})
		})
	},
	updateOfficeTheme ({ commit }, data) {
		return new Promise((resolve, reject) => {
			OfficeResource.updateOfficeTheme(data.id, data.payload).then((response) => {
				if (response.status === 200) {
					resolve(response.data)
				} else {
					reject(new Error('Une erreur est survenue'))
				}
			}).catch((error) => {
				reject(error)
			})
		})
	},
	updateOfficeHosts ({ commit }, data) {
		return new Promise((resolve, reject) => {
			const formData = new FormData();
			data.payload.forEach((host, i) => {
				formData.append(`hosts[${i}][name]`, host.name);
				formData.append(`hosts[${i}][domain]`, host.domain);
			})
			OfficeResource.updateOfficeHosts(data.id, formData).then((response) => {
				if (response.status === 200) {
					resolve(response.data)
				} else {
					reject(new Error('Une erreur est survenue'))
				}
			}).catch((error) => {
				reject(error)
			})
		})
	},
	updateOfficeLogo ({ commit }, data) {
		return new Promise((resolve, reject) => {
			const formData = new FormData();
			formData.append('image', data.logo)
			OfficeResource.updateOfficeLogo(data.id, formData).then((response) => {
				if (response.status === 200) {
					resolve(response.data)
				} else {
					reject(new Error('Une erreur est survenue'))
				}
			}).catch((error) => {
				reject(error)
			})
		})
	},
}



// WEBPACK FOOTER //
// ./src/store/modules/Office/actions.js